export const FIND_INDICATOR_IDS_SUCCESS = 'FIND_INDICATOR_IDS_SUCCESS';

export const findIndicatorIdsSuccess = ({ indicatorIds }) => ({
    type: FIND_INDICATOR_IDS_SUCCESS,
    payload: { indicatorIds },

});
